import React from 'react';

export const QuantityError = ({ qtyPerConfig, show }: { show: boolean; qtyPerConfig: number }) => {
    return show ? (
        <div className='pricing-info quantity-error'>
            <p className='dollar'>!</p>
            <div className='info-bubble show' style={{ textAlign: 'left' }}>
                <span>Please enter the quantity in the increment of </span>
                <span>{qtyPerConfig}</span>
            </div>
        </div>
    ) : null;
};
